import React from 'react'

import { BrandedAlertModal } from 'components/Modal'
import type { BrandedAction } from 'components/Modal/BrandedAlertModal/BrandedAlertModal'

interface SuccessActionProps {
  isOpen: boolean
  title: string
  description: string
  onConfirm: () => void
  onClose?: () => void
}

// T2-6549: success / info confirmations (e.g. "Application Withdrawn", "Job No
// Longer Available") now use the shared BrandedAlertModal so they match the
// TempStars design system (centered, constrained-width card) instead of the old
// full-width Popup dialog that stretched edge-to-edge.
const SuccessAction = ({
  isOpen,
  onConfirm,
  onClose,
  title,
  description,
}: SuccessActionProps) => {
  const actions: BrandedAction[] = [
    {
      label: 'OK',
      variant: 'primary',
      onClick: onConfirm,
      ariaLabel: 'success-action-confirm-button',
    },
  ]

  return (
    <BrandedAlertModal
      isOpen={isOpen}
      onClose={onClose ?? onConfirm}
      title={title}
      ariaLabel={title}
      actions={actions}
    >
      {description}
    </BrandedAlertModal>
  )
}

export default SuccessAction;
